import { TLCEvents } from "../../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { ApplicationData } from "../../ApplicationData";
import { LS2PacSearchDatabaseManager } from "../../managers/SearchDatabaseManager";
import { TitlesSearchClientManager } from "./TitlesSearchClientManager";

export class ReservesSearchClientManager extends TitlesSearchClientManager {
  constructor(options) {
	super(options);
    this.originalPageSize = options.pageSize;
    
    this.addExtraListeners();

    this.searchFilters = {
      department: "",
      course: "",
      instructor: "",
    };
  }
  getSearchParams() {
    return {
      searchTerm: "",
      startIndex: this.currentPage * this.pageSize,
      hitsPerPage: this.pageSize,

      departmentFilter: this.searchFilters.department,
      courseFilter: this.searchFilters.course,
      instructorFilter: this.searchFilters.instructor,

      branchFilters: ApplicationData.branchLimitsUtil.getLimitedBranches(),
      sortType: this.sortingData.sortKey,
      targetAudience: "",
    };
  }
  addExtraListeners() {
    var _this = this;

    TLCEvents.on(LS2PAC_CONSTANTS.Events.onLogoutResponse, function (event) {
      _this.resetPageCache(true);
      if (_this.searchTermInfo) {
        _this.searchTermInfo.value = "";
        //TODO: store search filters -- department, course, instructor
      }
    });

    TLCEvents.on(
      LS2PAC_CONSTANTS.Events.onGetCurrentReserveSearchFiltersResponse,
      function (event) {
        _this.searchFilters = event.searchFilters;
      }
    );

    TLCEvents.on(
      LS2PAC_CONSTANTS.Events.onFireReservesSearch,
      function (event) {
        _this.searchFilters.department = event.department;
        _this.searchFilters.course = event.department;
        _this.searchFilters.instructor = event.instructor;

        _this.extraDataToPassBack.isAdvanced = true;

        _this.resetPageCache(true);
        _this.fireSearch(event);
        //_this.addHistory( event );
      }
    );

    TLCEvents.on(
      LS2PAC_CONSTANTS.Events.onChangeBranchLimits,
      function (event) {
        if (_this.hasResults === true) {
          _this.resetPageCache(true);
          _this.fireSearch(event);
          _this.addHistory(event);
        }
      }
    );

    TLCEvents.on(
      LS2PAC_CONSTANTS.Events.onFireAdvancedSearch,
      function (event) {
        _this.stopSpinner();
      }
    );
  }
  onBeforeFireSearch(event) {
    if (!event.fromHistory) {
      this.resetPageCache(true);
    }

    if (event.sortKey) {
      this.sortingData.sortKey = event.sortKey;
    }

    if (event.page) {
      this.currentPage = event.page;
    }

    if (event.branchFilters) {
      this.branchFilters = event.branchFilters;
    }

    if (!event.databaseKey) {
      event.databaseKey = LS2PacSearchDatabaseManager.getCurrentDatabaseKey();
    }

    if (event.instructor != undefined) {
      this.searchFilters.instructor = event.instructor;
    }

    if (event.course != undefined) {
      this.searchFilters.course = event.course;
    }

    if (event.department != undefined) {
      this.searchFilters.department = event.department;
    }

    TLCEvents.trigger(
      LS2PAC_CONSTANTS.Events.onSetCurrentReserveSearchFilters,
      { searchFilters: this.searchFilters }
    );

    super.onBeforeFireSearch(event);

    this.addHistory(event);
  }
  getURLParamsForHash(event) {
    var hash =
      "section=" +
      this.searchEvent +
      "&page=" +
      this.currentPage +
      "&sortKey=" +
      this.sortingData.sortKey +
      "&db=" +
      this.extraDataToPassBack.databaseKey +
      "&branchFilters=" +
      JSON.stringify(this.getBranchFilters());

    if (event.viewName) {
      hash += "&view=" + event.viewName;
    }

    if (this.searchFilters.department.length > 0) {
      hash += "&department=" + this.searchFilters.department;
    }
    if (this.searchFilters.course.length > 0) {
      hash += "&course=" + this.searchFilters.course;
    }
    if (this.searchFilters.instructor.length > 0) {
      hash += "&instructor=" + this.searchFilters.instructor;
    }

    return hash;
  }
  getSearchCount() {
    var _this = this;
    if (this.isCurrent()) {
      super.getSearchCount();
    } else {
      this.stopSpinner();
    }
  }
  stopSpinner() {
    var _this = this;
    setTimeout(function () {
      $(
        "#" +
          _this.extraDataToPassBack.databaseKey +
          LS2PAC_CONSTANTS.Ids.SearchPage.tabHitsSuffix
      ).spin(false);
    }, 1000);
  }
}
